import React from "react";
import { useParams } from "react-router-dom";
import { getGuestSingle } from "services/getApi";

const options = {
  weekday: "long",
  month: "numeric",
  day: "numeric",
  year: "numeric",
};

export default function PrintSingle() {
  const params = useParams();
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    getGuestSingle(params.id).then((res) => {
      setData(res.data);
    });

    window.addEventListener("afterprint", () => {
      document.getElementById("navbarMain")?.classList.remove("hidden");
      setLoading(false);
    });
  }, []);

  function handlePrint() {
    setLoading(true);
    document.getElementById("navbarMain")?.classList.add("hidden");
    setTimeout(() => {
      window.print();
    }, 300);
  }

  return (
    <div className="m-auto max-w-xl p-4">
      <div id="print-area" className="bg-white shadow-lg">
        
        {/* هدر فاکتور */}
        <div className="border-b-2 border-gray-900 p-3 text-center">
          <h1 className="text-lg font-bold">فاکتور رسمی</h1>
          <p className="text-xs mt-1">نرم افزار مهمانسرا دانشگاه شمال</p>
        </div>

        {/* شماره و تاریخ فاکتور */}
        <div className="flex justify-between items-center px-3 py-2 border-b border-gray-300">
          <div className="text-right">
            <p className="text-[10px] text-gray-600">شماره فاکتور</p>
            <p className="text-sm font-bold">#{data?.id || "---"}</p>
          </div>
          <div className="text-left">
            <p className="text-[10px] text-gray-600">تاریخ صدور</p>
            <p className="text-sm font-bold">
              {data && new Date(data.createdAt).toLocaleString("fa-IR", options)}
            </p>
          </div>
        </div>

        {/* محتوای اصلی - دو ستونه */}
        <div className="grid grid-cols-2 gap-3 p-3">
          
          {/* ستون راست - اطلاعات مشتری */}
          <div className="border border-gray-300 p-2">
            <h2 className="text-xs font-bold mb-2 pb-1 border-b border-gray-400">
              مشخصات مهمان
            </h2>
            <div className="space-y-2 text-[11px]">
              <div>
                <span className="text-gray-600 block text-[10px]">نام و نام خانوادگی:</span>
                <span className="font-semibold">{data?.fullname || "---"}</span>
              </div>
              <div>
                <span className="text-gray-600 block text-[10px]">شماره تماس:</span>
                <span className="font-semibold">{data?.phone || "---"}</span>
              </div>
              <div>
                <span className="text-gray-600 block text-[10px]">آدرس:</span>
                <span className="font-semibold">{data?.city || "---"}</span>
              </div>
              {data?.description && (
                <div>
                  <span className="text-gray-600 block text-[10px]">توضیحات:</span>
                  <span className="font-normal text-[10px]">{data.description}</span>
                </div>
              )}
            </div>
          </div>

          {/* ستون چپ - جزئیات رزرو */}
          <div className="border border-gray-300 p-2">
            <h2 className="text-xs font-bold mb-2 pb-1 border-b border-gray-400">
              جزئیات رزرو
            </h2>
            <div className="space-y-2 text-[11px]">
              <div className="flex justify-between border-b border-gray-200 pb-1">
                <span className="text-gray-600">شماره اتاق:</span>
                <span className="font-bold">{data?.number_room || "---"}</span>
              </div>
              <div>
                <span className="text-gray-600 block text-[10px]">تاریخ ورود:</span>
                <span className="font-semibold">{data?.login_date || "---"}</span>
              </div>
              <div>
                <span className="text-gray-600 block text-[10px]">تاریخ خروج:</span>
                <span className="font-semibold">{data?.logout_date || "---"}</span>
              </div>
              <div className="flex justify-between border-t border-gray-200 pt-1">
                <span className="text-gray-600">مدت اقامت:</span>
                <span className="font-bold">{data?.stay_time || "0"} روز</span>
              </div>
            </div>
          </div>

        </div>

        {/* محاسبات مالی */}
        <div className="px-3 pb-3">
          <div className="border-2 border-gray-400 p-2">
            <h2 className="text-xs font-bold mb-2 pb-1 border-b border-gray-400">
              محاسبات مالی
            </h2>
            <div className="text-[11px] space-y-1.5">
              <div className="flex justify-between py-1 border-b border-gray-200">
                <span>قیمت اتاق (هر شب):</span>
                <span className="font-semibold">
                  {data?.price_room.toLocaleString() || "0"} تومان
                </span>
              </div>
              <div className="flex justify-between py-1 border-b border-gray-200">
                <span>تعداد شب:</span>
                <span className="font-semibold">{data?.stay_time || "0"} شب</span>
              </div>
              <div className="flex justify-between py-1 border-b border-gray-200">
                <span>جمع کل:</span>
                <span className="font-semibold">
                  {data && (data.price_room * data.stay_time).toLocaleString()} تومان
                </span>
              </div>
              <div className="flex justify-between py-1 border-b border-gray-300">
                <span>تخفیف ({data?.discount || "0"}%):</span>
                <span className="font-semibold">
                  {data && (
                    (data.price_room * data.stay_time * data.discount) / 100
                  ).toLocaleString()} تومان
                </span>
              </div>
              <div className="flex justify-between py-2 px-2 bg-gray-900 text-white mt-2">
                <span className="text-xs font-bold">مبلغ قابل پرداخت:</span>
                <span className="text-sm font-bold">
                  {data?.price.toLocaleString() || "0"} تومان
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* امضاها */}
        <div className="flex justify-between items-end px-3 py-3 border-t border-gray-300">
          <div className="text-center">
            <div className="h-12 mb-1"></div>
            <div className="border-t border-gray-500 pt-1 w-28">
              <p className="text-[10px]">امضاء مسئول</p>
            </div>
          </div>
          <div className="text-center">
            <div className="h-12 mb-1"></div>
            <div className="border-t border-gray-500 pt-1 w-28">
              <p className="text-[10px]">امضاء مهمان</p>
            </div>
          </div>
        </div>

        {/* فوتر */}
        <div className="bg-gray-900 text-white text-center py-2 text-[10px]">
          <p>این فاکتور به صورت سیستمی صادر شده است</p>
        </div>

      </div>

      {!loading && (
        <button
          onClick={handlePrint}
          className="btn btn-primary w-full mt-6 no-print shadow-lg hover:shadow-xl transition-shadow"
        >
          🖨️ چاپ فاکتور
        </button>
      )}

      <style jsx>{`
        @media print {
          @page {
            size: A5 portrait;
            margin: 5mm;
          }
          
          body * {
            visibility: hidden;
          }
          
          #print-area,
          #print-area * {
            visibility: visible;
          }
          
          #print-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            box-shadow: none !important;
            margin: 0;
            padding: 0;
          }
          
          .no-print {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}
